import Vue from "vue";
import Vuex from "vuex";

let store;
Vue.use(Vuex);

store = new Vuex.Store({
    state:{
        // user:{

        // },
        //是否缩展
        isCollapse:true,
        defaultAcitveIndex:'/dashboard'
    },
    getters:{
    },
    mutations:{
        collapseChange(state){
            state.isCollapse = !state.isCollapse;
        },
        activeIndexChange(state,path){
            state.defaultAcitveIndex = path;
        },
        // setUser(state,user){
        //     state.user = user;
        // }
    },
    actions:{

    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js